export default "__VITE_ASSET__DjBsAAZ7__"